import uploadPrintFileOrderPlacedHtml from './uploadPrintFileOrderPlaced.html';

class UploadPrintFileOrderPlacedController {
    constructor($scope, $http, CheckoutService, SnackbarService, translateService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.service = CheckoutService;
        this.SnackbarService = SnackbarService;
        this.translate = translateService;

        this.orderId = null;
        this.orderItemId = null;

        this.error = false;

        this.uploadFile = null;
        this.uploadProgress = 0;
    }

    uploaderProgress(result) {
        this.uploadProgress = result;
    }

    uploaderComplete(result) {
        this.uploadFile = result;
    }

    uploaderError(result) {
        this.errors.push({
            message: result,
            type: 'error'
        });
    }

    save() {
        if (this.uploadFile instanceof Object && typeof(this.uploadFile.file_id) !== 'undefined') {
            this.$http.post('/ajax/orders/save-upload-print-file', {
                orderId: this.orderId,
                orderItemId: this.orderItemId,
                printFileId: this.uploadFile.file_id
            }, {
                headers: {'Content-Type': 'application/json'}
            }).then(
                (response) => {
                    window.location.pathname = 'user/orders/details/' + this.orderId;
                },
                () => {
                    this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);
                }
            );
        } else {
            this.SnackbarService.add('Plik druku nie został wgrany.', 'error', true, 3000);
        }
    }
}

let uploadPrintFileOrderPlacedComponent = {
    bindings: {
        'orderId': '<',
        'orderItemId': '<'
    },
    template: uploadPrintFileOrderPlacedHtml,
    controller: UploadPrintFileOrderPlacedController
};

export default uploadPrintFileOrderPlacedComponent;